export enum ProductType {
  MieterPlus = 'MIETER_PLUS',
  WohnenPlus = 'WOHNEN_PLUS',
  KaeuferPlus = 'KAEUFER_PLUS',
}
export interface Product {
  productType: ProductType;
}
export type ProductApiResponse = Product[];
